import { Component, inject } from '@angular/core';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import { SWCTYPE_CONFIG, SWCTYPE_FIELDS } from './swc-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';
import { SWCTypeService } from '../proxy/planning/controllers';
import { SWCTypeCreateDto, SWCTypeDto, SWCTypeExcelDownloadDto, SWCTypeUpdateDto } from '../proxy/planning/dtos/swctype';

@Component({
  selector: 'app-swc-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, SWCTypeService, ConfirmationService],
  templateUrl: './swc-type.html',
  styleUrl: './swc-type.scss',
})
export class SwcType extends BaseCrudComponent<
  SWCTypeDto,
  SWCTypeCreateDto,
  SWCTypeUpdateDto,
  SWCTypeExcelDownloadDto
> {
  service = inject(SWCTypeService);
  config = SWCTYPE_CONFIG;
  fields = SWCTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: SWCTypeDto): SWCTypeUpdateDto {
    return {
      name: data.name,
      code: data.code,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'SWCType';
  }
}
